import Config from "./vueconfig.js";
/**
 * environment
 * @function getAppId
 * @function getAppName
 * @function getApiUrl
 * @function getApiModuleUrl
 * @function getBlobUrl
 * @function getMiscUrl
 * @function getShoppingCartUrl
 * @function getApiShoppingCartUrl
 * @function getApi
 * api config str
 * @function getCampaignConfig
 * @function getDashboardConfig
 * @function getCategoryConfig
 * @function getHistoryConfig
 * setting
 * @function getCacheType
 * custom
 * @function getCampaignListDevApp
 * @function getCategoryMenuDev
 */
export default {

    //#region normal environment
    getAppId: function () {
        return Config().client_id;
    },
    getAppName: function () {
        return Config().appname;
    },
    getAgencyId: function () {
        return Config().agency_id;
    },
    getApiUrl: function() {
        return Config().bzbsUrl;
    },
    getApiModuleUrl: function () {
        return Config().bzbsModuleUrl;
    },
    getApiDeliveryModuleUrl: function () {
        return Config().bkDeliveryModuleUrl;
    },
    getBlobUrl: function() {
        return Config().bzbsBlobUrl;
    },
    getMiscUrl: function() {
        return Config().miscUrl;
    },
    getShoppingCartUrl: function() {
        return Config().webShoppingCartUrl;
    },
    getApiShoppingCartUrl: function () {
        return Config().apiShoppingCartUrl;
    },
    getApi: function () {
        return Config().api;
    },
    //#endregion normal environment

    //#region config str
    getCampaignConfig: function() {
        return Config().campaignConfig;
    },
    getDashboardConfig: function() {
        return Config().dashboardConfig;
    },
    getCategoryConfig: function() {
        return Config().categoryConfig;
    },
    getHistoryConfig: function() {
        return Config().historyConfig;
    },
    getCouponConfig: function () {
        return Config().couponConfig;
    },
    getGoogleMapsConfig: function() {
        return Config().googleMapKey;
    },
    //#endregion config str

    //#region setting
    getCacheType: function() {
        return Config().setting.cache;
    },
    getAddressType: function() {
        return Config().setting.addressType;
    },
    getFirebaseSetup: function () {
        return Config().firebase;
    },
    //#endregion setting

    //#region custom
    getDashboardHome: function (tier) {
        let config = this.getDashboardConfig().homeDashboard;
        return config.replace('{tier}', tier);
    },
    getDashboardFreshTaste: function () {
        return this.getDashboardConfig().freshTasteDashboard;
    },
    getDashboardMadeToOrder: function () {
        return this.getDashboardConfig().madeToOrderDashboard;
    },
    getDashboardPromotions: function () {
        return this.getDashboardConfig().promotionDashboard;
    },

    getCampaignListDevApp: function() {
        return this.getCampaignConfig().campaignListConfig;
    },
    getCampaignSearchConfig: function(tier){
        let config = this.getCampaignConfig().searchConfigList;
        return config.replace('{tier}', tier);
    },
    getDashboardCatering: function () {
        return this.getDashboardConfig().cateringDashboard;
    },
    getSubscriptionConfig: function() {
        return this.getCampaignConfig().subscriptionConfig;
    },

    // category
    getCategoryMenuDev: function () {
        return this.getCategoryConfig().menuCategory;
    },
    getCategoryMenuReward: function () {
        return this.getCategoryConfig().menuCategoryReward;
    },
    getCategoryHome: function (tier) {
        let config = this.getCategoryConfig().menuCategoryHome;
        return config.replace('{tier}', tier);
    },


    getHistoryPurchaseList: function() {
        return this.getHistoryConfig().purchase;
    },
    getHistoryPurchaseUnUsed: function() {
        return this.getHistoryConfig().purchase_unused;
    },
    getHistoryPurchaseUsed: function() {
        return this.getHistoryConfig().purchase_used;
    },
    getCouponConfigList: function () {
        return this.getCouponConfig().coupon;
    },
    getCouponDeliveryConfigList: function () {
        return this.getCouponConfig().coupon_delivery;
    },
    getCouponPickupConfigList: function () {
        return this.getCouponConfig().coupon_pickup;
    },
    getGoogleMapsKey: function() {
        return this.getGoogleMapsConfig().googleKey;
    },

    getMinorDeleteAccountLink: function (localeCode) {
        if (localeCode == 1033) {
            return Config().minorPrivacyUrl.en;
        } else {
            return Config().minorPrivacyUrl.th;
        }
    },
    //#endregion custom
}
